import { render, staticRenderFns } from "./ListBody.vue?vue&type=template&id=22c17a0a&scoped=true&"
import script from "./ListBody.vue?vue&type=script&lang=js&"
export * from "./ListBody.vue?vue&type=script&lang=js&"
import style0 from "./ListBody.vue?vue&type=style&index=0&id=22c17a0a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../salespro-dev/salespro-dev/sources/client/salespro-dev-admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c17a0a",
  null
  
)

export default component.exports